import React, { useState, useEffect } from "react";
import {
  getSimilarProductList,
  getSimilarProductListClear,
} from "../../../redux/product/actions";
import {
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  convertTimeInHourAndMin,
  getProcureInfo,
  ProductCardPriceInfo,
  redirectToPageUtil,
  SessionKeys,
} from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import CONFIG from "../../../utils/config";
import { useNavigate } from "react-router-dom";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import Slider from "react-slick";
import PrevArrow from "../../LearningPaths/PrevArrow";
import NextArrow from "../../LearningPaths/NextArrow";
import useLogin from "../../../custom-hooks/useLogin";
import {
  getAssignBrokerCourseClear,
  getAssignCourseClear,
} from "../../../redux/courses/actions";

const settings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const SimilarCoachings = () => {
  const [coachingData, setCoachingData] = useState(
    CONFIG.INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA
  );
  const [isLoading, setIsLoading] = useState(true);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let isMobile = false;
  const { isLoggedIn } = useLogin();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  const serviceCode = paramsReq.service_code;
  const provider_name = paramsReq.provider_name;
  const provider_id = paramsReq.provider_id;
  const service_id = paramsReq.service_id;

  const similarProductsResponse = useSelector(
    (state) => state.product.similarProductList
  );
  const assignCourse = useSelector((state) => state.courses.assignCourse);
  const assignBrokerCourse = useSelector(
    (state) => state.courses.assignBrokerCourse
  );

  const authBroker = useSelector((state) => state.auth.authBroker);

  const [courseData, setCourseData] = useState({});

  useEffect(() => {
    if (!_.isEmpty(similarProductsResponse)) {
      console.log("simi--", similarProductsResponse);
      if (similarProductsResponse.status === "success") {
        const listData = similarProductsResponse?.payload?.payload;
        for (let data of listData) {
          data.is_recurring = false;
          if (data.payment_frequency !== "One time") {
            data.is_recurring = true;
          }
        }
        console.log("List", listData);
        formatDataForProductCard(listData);
        setIsLoading(false);
      } else {
        setCoachingData([]);
        setIsLoading(false);
      }
    }
  }, [similarProductsResponse]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getSimilarProductList({
        module: "getSimilarProducts",
        postData: {
          service_id: service_id,
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
    return () => {
      dispatch(getSimilarProductListClear());
    };
  }, [service_id]);

  useEffect(() => {
    if (assignCourse?.status === "success" && !_.isEmpty(courseData)) {
      dispatch(getAssignCourseClear());
      goToModuleDetail(courseData);
    }
  }, [assignCourse, courseData]);

  useEffect(() => {
    if (assignBrokerCourse?.status === "success" && !_.isEmpty(courseData)) {
      dispatch(getAssignBrokerCourseClear());
    }
  }, [assignBrokerCourse]);

  const goToModuleDetail = (courseData) => {
    let paramsReq = {
      source: courseData?.source,
      cid: courseData.id ? courseData.id : courseData?.wc_post_id,
      is_paid: "true",
    };
    if (courseData.course_categoryId) {
      paramsReq.catId = courseData.course_categoryId;
      paramsReq.via_cat = "true";
    } else if (courseData.isLevel) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.is_level = "true";
      paramsReq.level_id = courseData.level_id;
    } else if (courseData.lp_id) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.via_lp = "true";
    }
    if (provider_id) {
      paramsReq.provider_id = provider_id;
      paramsReq.provider_name = provider_name;
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/moduleDetail/${courseData?.crscd}/?c=${encodedUrl}`;

    sessionStorage.setItem("moduleForTour", url);
    navigate(url);
  };

  const formatDataForProductCard = (coachingData) => {
    console.log("coachingData", coachingData);
    setCoachingData(CONFIG.INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA);
    let eventArr = [];
    for (let course of coachingData) {
      let tags = [];
      let btnTitle = "Explore";
      if (course.provider?.provider_display_name) {
        tags.push(course.provider.provider_display_name);
      }
      if (course.product_type === "bundle") {
        tags.push("Combo");
      }
      if (course.product_type === "learningpath") {
        tags.push("Learning Path");
      }
      if (
        course.product_type === "bundle" ||
        course.product_type === "learningpath"
      ) {
        if (course.learningpath_count > 0) {
          tags.push(
            `${course.learningpath_count} Learning Path${
              course.learningpath_count > 1 ? "s" : ""
            }`
          );
        }
        if (course.course_count > 0)
          tags.push(
            `${course.course_count} Course${course.course_count > 1 ? "s" : ""}`
          );
        if (course.video_count > 0)
          tags.push(
            `${course.video_count} Video${course.video_count > 1 ? "s" : ""}`
          );
        if (course.event_count > 0)
          tags.push(
            `${course.event_count} Event${course.event_count > 1 ? "s" : ""}`
          );
      } else if (course.product_type === "video") {
        tags.push("Video");
        tags.push(`${course.views} View${course.views > 1 ? "s" : ""}`);
      } else if (course.product_type === "service") {
        tags.push("Services");
      } else {
        tags.push("Course");
        if (course.lessons) {
          tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
        }

        if (
          (course?.source === "ecom" || course?.source === "xsel") &&
          !course?.purchased_info?.is_purchased &&
          course?.purchased_info?.selling_price != 0
        ) {
          btnTitle = "Explore";
        } else if (
          course.crs_progress === "" ||
          course.crs_progress === undefined ||
          course.crs_progress === null ||
          course.crs_progress === 0
        ) {
          btnTitle = "Start course";
        } else if (course.crs_progress > 0 && course.crs_progress < 100) {
          btnTitle = "Resume course";
        } else if (course.crs_progress >= 100) {
          btnTitle = "Revisit course";
        }
      }
      if (course.duration) {
        tags.push(
          convertMinutesToHoursAndMinutes(
            convertSecondsToMins(course?.duration)
          )
        );
      }

      let priceInfo = getProcureInfo(course.purchased_info);
      course.priceInfo = priceInfo;
      course.isLoggedIn = isLoggedIn;

      if (provider_id) {
        course.provider_id = provider_id;
        course.provider_name = provider_name;
      }

      eventArr.push({
        id: course?.id,
        ecom_id: course?.ecom_id ? course?.ecom_id : course?.wc_post_id,
        is_like: course?.is_like ? course?.is_like : false,
        is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
        is_wishlist: course?.is_addtowishlist,
        dbId: course?.list_id,
        productType: course?.product_type,
        productOrigin: course?.origin,
        title: course.name,
        logoURL: course.provider?.provider_img
          ? course.provider?.provider_img
          : "",
        bannerURL: course.imageURL,
        tagsArray: tags,
        description: course.short_description,
        btnTitle: btnTitle,
        progress: course.crs_progress,
        isLoggedIn: isLoggedIn,
        btnAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        descAction: {},
        bannerAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        showHeader: true,
        showProviderIcon: true,
        showPlayButton: course?.product_type === "video" ? true : false,
        duration: convertTimeInHourAndMin(course?.duration),
        showLikeMenu: true,
        showBody: true,
        showFooter: true,
        showProgress: _.toNumber(course.crs_progress) > 0 ? true : false,
        cardClassName: "",
        rightBtnIcon: "/images/arrow-right.svg",
        leftBtnIcon: "",
        updatedAt: course?.product_type === "service" ? "" : course?.created_dt,
        priceInfo,
        isBundle: course?.product_type === "bundle",
        bundles: course?.bundles,
        show4: true,
      });
    }

    console.log("event-array---", eventArr);
    setCoachingData(eventArr);
  };

  useEffect(() => {
    console.log("coac--", coachingData);
  }, [coachingData]);
  return (
    <>
      <section className="recommended-section">
        <div className="container">
          {!_.isEmpty(coachingData) && (
            <div className="row">
              <div className="col-md-8 col-12">
                <div className="subscriptions-row">
                  {isLoading ? (
                    <h3 className="subs-course-title">
                      <ShimmerScreen case="rect" height="2rem" width="30rem" />
                    </h3>
                  ) : (
                    <h3 className="subs-course-title">Similar Products</h3>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="row recommend-slide">
            <Slider {...settings}>
              {coachingData?.length === 0
                ? ""
                : coachingData.map((video, i) => {
                    return (
                      <ProductCardComponent {...video} key={`video-${i + 1}`} />
                    );
                  })}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default SimilarCoachings;
